<div class="kpi-cards" *ngIf="snapshot">
    <div class="kpi-card">
        <div class="kpi-label">{{ 'user_records.analytics.subscribers' | translate }}</div>
        <div class="kpi-value">{{ snapshot.subscribersCount | number }}</div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'user_records.analytics.population' | translate }}</div>
        <div class="kpi-value">{{ snapshot.population | number }}</div>
        <div class="kpi-subtitle muted" *ngIf="snapshot.population === 0">
            {{ 'user_records.analytics.population_not_configured' | translate }}
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'user_records.analytics.subscription_rate' | translate }}</div>
        <div class="kpi-value">{{ snapshot.subscriptionRate }}%</div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'user_records.analytics.active_citizen_cards' | translate }}</div>
        <div class="kpi-value">{{ snapshot.activeCitizenCards | number }}</div>
    </div>
</div>
